import html2pdf from 'html2pdf.js';

export default (name, id) => () => {
  var element = document.getElementById(id);
  var opt = {
    margin:       2,
    filename:     name,
    image:        { type: 'jpeg', quality: 1 },
    jsPDF:        { unit: 'mm', format: 'ledger', orientation: 'portrait' }
  };
  html2pdf().set(opt).from(element).save();
};

